import { api } from "../../lib/api";
export const updateProjectDetails = async (projectId, queryParams, updateProjectDetailsRequest) => {
    const config = {
        params: {
            ...(queryParams.partyNumber && { partyNumber: queryParams.partyNumber }),
            ...(queryParams.projectStatus && { projectStatus: queryParams.projectStatus }),
            ...(queryParams.downSelectPartyNumber && { downSelectPartyNumber: queryParams.downSelectPartyNumber })
        }
    };
    const { data } = await api.patch(`/projects/${projectId}`, updateProjectDetailsRequest, config);
    return { data };
};
